export function getLocalDateFormat() {
  const sample = new Date(2000, 10, 22)
  const formatted = new Intl.DateTimeFormat(navigator.language).format(sample)
  return formatted.replace('2000', 'yy').replace('22', 'dd').replace('11', 'mm')
}

export function formatDate(date: string): string {
  return new Date(date).toLocaleDateString(undefined, {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export function formatShortDate(date: string): string {
  return new Date(date).toLocaleDateString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}

export function formatMonthDay(date: string): string {
  return new Date(date).toLocaleDateString(undefined, {
    month: '2-digit',
    day: '2-digit'
  })
}

export function formatDuration(totalSeconds: number) {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = Math.floor(totalSeconds % 60)
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}
